import { createFileRoute } from '@tanstack/react-router'
import { AssemblyPage } from '../../../components/assemblies/AssemblyPage'

type AssemblySearch = {
  tab?: 'attendance' | 'details' | 'convocation' | 'sitting'
  resolution?: string
  /** Resolutions search words (the filter lives in the URL). */
  q?: string
  /** Resolutions outcome filter: adopted | rejected | not_voted. */
  outcome?: 'adopted' | 'rejected' | 'not_voted'
}

/** One assembly: the selected tab, resolution and resolution filters live in the URL. */
export const Route = createFileRoute('/$org/assemblies/$uid')({
  component: AssemblyPage,
  validateSearch: (search: Record<string, unknown>): AssemblySearch => {
    const out: AssemblySearch = {}
    if (search.tab === 'attendance' || search.tab === 'details' || search.tab === 'convocation' || search.tab === 'sitting') {
      out.tab = search.tab
    }
    if (search.resolution) out.resolution = String(search.resolution)
    if (typeof search.q === 'string' && search.q.trim()) out.q = search.q
    if (search.outcome === 'adopted' || search.outcome === 'rejected' || search.outcome === 'not_voted') out.outcome = search.outcome
    return out
  },
})
